import { debounce } from 'throttle-debounce';

// タップ対応デバイスに touch-deviceクラスを付与
export function addTouchDeviceClass() {
  if (
    'maxTouchPoints' in window.navigator &&
    window.navigator.maxTouchPoints > 0
  ) {
    document.body.classList.add('touch-device');
  }
}

/**
 * https://zenn.dev/tak_dcxi/articles/2ac77656aa94c2cd40bf
 * @memo: 100dvhが主流になったら消したい
 */
export function observeFillHeight() {
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  const onResize = debounce(50, () => setFillHeight());

  window.addEventListener('resize', onResize, false);
  setFillHeight();

  return {
    disconnect: () => {
      window.removeEventListener('resize', onResize);
    },
  };
}

/**
 * php json_encode を js objectに変換
 *
 * @param {string} phpjson
 * @returns {array | object | null}
 */
export function castJsonToJSObject(phpjson) {
  if (!phpjson) return null;

  phpjson = phpjson + '';

  const data = phpjson.replace('&quot;', '#');

  try {
    return JSON.parse(data);
  } catch (err) {
    console.log(err);
    return null;
  }
}

/**
 * @returns {number}
 */
export function genUniqKey() {
  return (Math.random() * 0x80000000) | 0;
}

/**
 * スクロールY値を返す
 *
 * @param {Window|string} target
 * @return  {number}
 */
export function getScrollY(target) {
  target = target || window;
  if (window === target) {
    return window.pageYOffset || window.scrollY;
  } else if (typeof target !== 'string') {
    const elm = document.querySelector(target);
    return elm ? elm.scrollTop : 0;
  } else {
    return 'scrollTop' in target ? target.scrollTop : 0;
  }
}
